import { createSlice } from '@reduxjs/toolkit';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
};

const employeeAnnouncementSlice = createSlice({
  name: 'employeeAnnouncement',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
  },
});

const token = JSON.parse(localStorage.getItem('authenticated'));

const { setFormLoading } = employeeAnnouncementSlice.actions;

export const { setRecord } = employeeAnnouncementSlice.actions;

export const initPageInfo = (unid) => async (dispatch) => {
  try {
    dispatch(setFormLoading(true));

    let url = `/employee-announcement/index-info?`;
    url += `auth_token=${token}`;

    const data = JSON.stringify({
      data_unid: unid,
    });

    RequestApi(url, { data })
      .then((res) => {
        if (res.data.status === 'success') {
          dispatch(setRecord(res.data.record));
        } else {
          NotificationMessage({ message: res.data.msg, status: res.data.status });
        }

        dispatch(setFormLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setFormLoading(false));
        NotificationMessage({ message: err.toString(), status: 'error' });
      });
  } catch (ex) {
    dispatch(setFormLoading(false));
    NotificationMessage({ message: ex.toString(), status: 'error' });
  }
};

const employeeAnnouncementReducer = employeeAnnouncementSlice.reducer;

export default employeeAnnouncementReducer;
